import React, { useState } from 'react';

import { ReactComponent as ProposalsEmptyStateIllustration } from '../../../../assets/rebranding/feedback/empty-spaces/sem-anuncio.svg';
import { EmptyState } from '../../../components/EmptyState';
import { ProposalTips } from '../components/Modal';

export function ProposalsEmptyState(): JSX.Element {
  const [modalOpen, setModalOpen] = useState(false);

  function handleClick() {
    setModalOpen(true);
  }

  return (
    <>
      <EmptyState
        Illustration={ProposalsEmptyStateIllustration}
        title="seu anúncio ainda não recebeu mensagens"
        body="Vamos notificar você quando uma mensagem chegar. Enquanto isso, confira dicas que vão ajudar na hora de negociar."
        buttonLabel="conferir dicas"
        buttonAction={handleClick}
        hideButtonOnDesk
      />

      <ProposalTips modalOpen={modalOpen} setModalOpen={setModalOpen} />
    </>
  );
}
